<template>
  <div class="pannel10">
    <div class="pc-conent">
      <div class="conent-box">
        <div class="left-box">
          <p class="about-us">关于我们</p>
          <p class="title-name">北京美到家科技有限公司</p>
          <div class="Introduction">
            <p v-for="(item, idx) in maintext" :key="idx">{{ item }}</p>
          </div>
        </div>
        <div class="right-box">
          <div class="map">
            <!-- class="map" :center="{ lng: 116.404, lat: 39.915 }" :zoom="16" :scroll-wheel-zoom="true" -->
            <baidu-map
              :center="center"
              :zoom="zoom"
              :dragging="true"
              :scroll-wheel-zoom="true"
              class="map"
              @ready="handler"
              @click="getClickInfo"
              @moving="syncCenterAndZoom"
              @moveend="syncCenterAndZoom"
              @zoomend="syncCenterAndZoom"
            >
              <!-- //定位 -->
              <bm-geolocation
                anchor="BMAP_ANCHOR_BOTTOM_RIGHT"
                :showAddressBar="true"
                :autoLocation="true"
              ></bm-geolocation>
              <!-- //添加一个小红点的，并将当前的经纬度写入数据中 -->
              <bm-marker
                :position="{ lng: this.center.lng, lat: this.center.lat }"
                animation="BMAP_ANIMATION_BOUNCE"
              ></bm-marker>
            </baidu-map>
          </div>
        </div>
      </div>
      <div class="contact-box">
        <div
          class="contact-item"
          :class="idx == 1 ? 'contact-item-r' : ''"
          v-for="(val, idx) in contactus"
          :key="idx"
        >
          <div class="contact-us">
            <p v-for="(item, idx) in val" :key="idx">{{ item }}</p>
          </div>
        </div>
      </div>
      <div class="recordation">
        <a href="https://beian.miit.gov.cn/" target="_blank">
          ©2020 美到家 (京)-经营性-2017-03-30 京公网安备11010502032676号
          京ICP备14042421号
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Pannel10",
  data() {
    return {
      baidumapSwitch: false,
      center: { lng: 116.463387, lat: 39.968743 },
      zoom: 16,
      location: "北京市",
      maintext: [
        "美图family重要成员之一。美到家是一家以技术创新、优质服务与卓越品质为驱动的公司，通过领先的技术，不断推动着智能美妆领域的迭代升级和产品创新。",
        "经过在美业的深耕和人工智能领域的探索，美到家推出了集人脸识别、人脸区域定位、AI测肤、妆容定制、化妆教学、造型师上门服务等于一体的个性化美妆生态应用，满足用户全时空、多层次的妆容需求；美到家还开发了集大数据人脸分析系统应用与美妆师专业经验相结合的智能上妆分析系统。",
        "美到家美妆养成生态应用和智能上妆分析系统的推出，实现了美妆行业产品3.0时代的到来，同时也是化妆品行业发展历程的“互联网+”。",
      ],
      contactus: [
        ["客服服务", "联系电话：400-077-0885", "Email：service@meidaojia.com"],
        ["商务合作", "联系人：010-52596069", "Email：support@meidaojia.com"],
      ],
    };
  },
  methods: {
    //百度地图初始化（这个一定要！否则地图回加载不出来）
    handler({ BMap, map }) {},
    //点击获取到当前经纬度
    getClickInfo(e) {
      console.log(e.point.lng);
      console.log(e.point.lat);
      this.center.lng = 116.463387;
      this.center.lat = 39.968743;

      // lng: 116.463387, lat: 39.968743
      // this.center.lng = e.point.lng;
      // this.center.lat = e.point.lat;
    },
    //双向绑定经纬度以及缩放尺寸
    syncCenterAndZoom(e) {
      const { lng, lat } = e.target.getCenter();
      // var l=116.463387;
      // var  a=39.968743
      // l= lng;
      // a = lat;

      this.center.lng = lng;
      this.center.lat = lat;
      // this.zoom = e.target.getZoom();
    },
    //经纬度同步
    baidumap() {
      // lng: 116.463387, lat: 39.968743
      // this.baiduDevicelocationx = 116.463387;
      //    this.baiduDevicelocationy = 39.968743;
      // this.handler()

      this.baiduDevicelocationx = this.center.lng;
      this.baiduDevicelocationy = this.center.lat;
    },
  },
  mounted() {
    // GL版命名空间为BMapGL
    // 按住鼠标右键，修改倾斜角和角度
    //  var map = new BMapGL.Map('allmap'); // 创建Map实例
    // map.centerAndZoom(new BMap.Point(116.463387,39.968743),16); // 初始化地图,设置中心点坐标和地图级别
    //  map.enableScrollWheelZoom(true); //开启鼠标滚轮缩放
    //  map.setHeading(64.5);
    //  map.setTilt(73);
  },
};
</script>

<style lang="less" scoped>
.pannel10 {
  margin-top: -1px; // 修复奇怪的1px间距
  padding: 50px 13% 100px;
  color: #fff;
  background-color: #000;

  .recordation {
    text-align: center;
    width: 100%;
    margin-top: 158px;
    a{
        color: #fff;
    }
  }
  .conent-box {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    p {
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
    }
    .left-box {
      flex: 0.8;
      // width: 50%;
      .about-us {
        // width: 144px;
        height: 42px;
        font-size: 30px;
        line-height: 42px;
        letter-spacing: 6px;
        margin-bottom: 87px;
      }
      .title-name {
        // width: 275px;
        height: 28px;
        font-size: 20px;
        line-height: 28px;
        letter-spacing: 5px;
      }
      .Introduction {
        margin-top: 31px;
        width: 100%;
        // height: 220px;
        p {
          font-size: 16px;
          // line-height: 22px;
          letter-spacing: 3px;
        }
      }
    }
    .right-box {
      width: 400px;
      // width: 50%;
      height: auto;
      .map {
        width: 100%;
        height: 230px;
        // background: #f0f0f0;
        top: 20%;
        transform: translate(0, 20%);
      }
    }
  }
  .contact-box {
    display: flex;
    width: 100%;
    height: 122px;
    justify-content: space-between;
    margin-top: 15px;
    .contact-item-r {
      width: 400px;
    }
    .contact-item {
      .contact-us {
        width: 100%;
        height: 100%;
        margin-top: 21px;
        p {
          font-size: 16px;
          line-height: 32px;
          letter-spacing: 2px;
        }
        p:first-child {
          margin-bottom: 35px;
        }
        p:last-child {
          margin-top: 23px;
        }
      }
    }
  }
}
@media screen and (max-width: 769px) {
  .pannel10 {
    margin-top: -1px; // 修复奇怪的1px间距
    padding: 50px 5% 100px;
    color: #fff;
    background-color: #000;
    position: relative;
    .recordation {
      text-align: center;
      width: 100%;
      margin-top: 20px;
    }
    .conent-box {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      position: relative;
      .left-box {
        width: 100%;
        flex: 1;
        .about-us {
          width: 100%;
          height: 25px;
          font-size: 18px;
          line-height: 25px;
          letter-spacing: 3px;
          text-align: center;
          margin-bottom: 30px;
        }
        .title-name {
          width: 100%;
          height: 22px;
          font-size: 16px;
          line-height: 22px;
          letter-spacing: 3px;
          text-align: center;
        }
        .Introduction {
          width: 100%;
          // width: 335px;
          font-size: 12px;
          line-height: 17px;
          letter-spacing: 1px;
          margin: 30px 0 0 0;
          font-weight: 400;
        }
      }
      .right-box {
        width: 100%;
        height: 200px;
        .map {
          width: 100%;
          height: 157px;
          // background: #f0f0f0;
          // margin-top: 25px;
        }
      }
    }
    .contact-box {
      display: flex;
      flex-direction: column;
      margin-top: 20px;
      height: auto;
      .contact-item {
        text-align: center;
        width: auto;
        .contact-us {
          width: 100%;
          height: 100%;
          margin-top: 21px;
          p {
            font-size: 16px;
            line-height: 32px;
            letter-spacing: 1px;
          }
          p:first-child {
            margin-bottom: 30px;
          }
          p:last-child {
            margin-top: 20px;
          }
        }
      }
    }
  }
}
</style>
